import { useForm } from "react-hook-form";
import "../css/Saving.css";

const SavingAccountLanding = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    console.log("Form submitted:", data);
  };

  return (
    <div className="shi-vt-saving-container">
      <h1 className="shi-vt-saving-title">Open Savings Account</h1>
      <form className="shi-vt-form" onSubmit={handleSubmit(onSubmit)} noValidate>
        
        {/* Profile Picture */}
        <div className="shi-vt-details-card">
          <div className="shi-vt-section-title">Profile Picture</div>
          <input 
            type="file"
            accept="image/*"
            className="shi-vt-input shi-vt-input-file"
            {...register("profilePic", { required: "Profile picture is required" })}
          />
          {errors.profilePic && <p className="shi-vt-error">{errors.profilePic.message}</p>}
        </div>

        {/* Customer Details */}
        <div className="shi-vt-details-card">
          <div className="shi-vt-section-title">Customer Details</div>
          <div className="shi-vt-grid">
            <div className="shi-vt-field">
              <label className="shi-vt-grid-label">Customer ID</label>
              <input
                type="text"
                placeholder="Enter Customer ID"
                className="shi-vt-input"
                {...register("customerId", { required: "Customer ID is required" })}
              />
              {errors.customerId && <p className="shi-vt-error">{errors.customerId.message}</p>}
            </div>

            <div className="shi-vt-field">
              <label className="shi-vt-grid-label">First Name</label>
              <input
                type="text"
                placeholder="First Name"
                className="shi-vt-input"
                {...register("firstName", { required: "First name is required" })}
              />
              {errors.firstName && <p className="shi-vt-error">{errors.firstName.message}</p>}
            </div>

            <div className="shi-vt-field">
              <label className="shi-vt-grid-label">Last Name</label>
              <input
                type="text"
                placeholder="Last Name"
                className="shi-vt-input"
                {...register("lastName", { required: "Last name is required" })}
              />
              {errors.lastName && <p className="shi-vt-error">{errors.lastName.message}</p>}
            </div>

            <div className="shi-vt-field">
              <label className="shi-vt-grid-label">Father's Name</label>
              <input
                type="text"
                placeholder="Father's Name"
                className="shi-vt-input"
                {...register("fatherName", { required: "Father's name is required" })}
              />
              {errors.fatherName && <p className="shi-vt-error">{errors.fatherName.message}</p>}
            </div>

            <div className="shi-vt-field">
              <label className="shi-vt-grid-label">Date of Birth</label>
              <input
                type="date"
                className="shi-vt-input"
                {...register("dob", { required: "Date of Birth is required" })}
              />
              {errors.dob && <p className="shi-vt-error">{errors.dob.message}</p>}
            </div>

            <div className="shi-vt-field">
              <label className="shi-vt-grid-label">Mobile Number</label>
              <input
                type="tel"
                placeholder="10-digit Mobile No."
                className="shi-vt-input"
                {...register("mobile", {
                  required: "Mobile number is required",
                  pattern: {
                    value: /^[6-9]\d{9}$/,
                    message: "Invalid mobile number",
                  },
                })}
              />
              {errors.mobile && <p className="shi-vt-error">{errors.mobile.message}</p>}
            </div>

            <div className="shi-vt-field">
              <label className="shi-vt-grid-label">Email</label>
              <input
                type="email"
                placeholder="Enter email address"
                className="shi-vt-input"
                {...register("email", { required: "Email is required" })}
              />
              {errors.email && <p className="shi-vt-error">{errors.email.message}</p>}
            </div>

            <div className="shi-vt-field">
              <label className="shi-vt-grid-label">Aadhaar Number</label>
              <input
                type="text"
                placeholder="12-digit Aadhaar"
                className="shi-vt-input"
                {...register("aadhaar", {
                  required: "Aadhaar number is required",
                  pattern: {
                    value: /^\d{12}$/,
                    message: "Aadhaar must be 12 digits",
                  },
                })}
              />
              {errors.aadhaar && <p className="shi-vt-error">{errors.aadhaar.message}</p>}
            </div>

            <div className="shi-vt-field">
              <label className="shi-vt-grid-label">PAN Number</label>
              <input
                type="text"
                placeholder="PAN Number"
                className="shi-vt-input"
                {...register("pan", {
                  required: "PAN number is required",
                  pattern: {
                    value: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                    message: "Invalid PAN format",
                  },
                })}
              />
              {errors.pan && <p className="shi-vt-error">{errors.pan.message}</p>}
            </div>

            <div className="shi-vt-field shi-vt-field-full">
              <label className="shi-vt-grid-label">Address</label>
              <input
                type="text"
                placeholder="Full Address"
                className="shi-vt-input"
                {...register("address", { required: "Address is required" })}
              />
              {errors.address && <p className="shi-vt-error">{errors.address.message}</p>}
            </div>
          </div>
        </div>

        {/* Documents */}
        <div className="shi-vt-details-card">
          <div className="shi-vt-section-title">Document Uploads</div>
          <div className="shi-vt-grid">
            <div className="shi-vt-field">
              <label className="shi-vt-grid-label">Aadhaar Front</label>
              <input type="file" accept="image/*,application/pdf" className="shi-vt-input shi-vt-input-file"
                {...register("aadhaarFront", { required: "Aadhaar front image is required" })}/>
              {errors.aadhaarFront && <p className="shi-vt-error">{errors.aadhaarFront.message}</p>}
            </div>
            <div className="shi-vt-field">
              <label className="shi-vt-grid-label">Aadhaar Back</label>
              <input type="file" accept="image/*,application/pdf" className="shi-vt-input shi-vt-input-file"
                {...register("aadhaarBack", { required: "Aadhaar back image is required" })}/>
              {errors.aadhaarBack && <p className="shi-vt-error">{errors.aadhaarBack.message}</p>}
            </div>
            <div className="shi-vt-field">
              <label className="shi-vt-grid-label">PAN Front</label>
              <input type="file" accept="image/*,application/pdf" className="shi-vt-input shi-vt-input-file"
                {...register("panFront", { required: "PAN front image is required" })}/>
              {errors.panFront && <p className="shi-vt-error">{errors.panFront.message}</p>}
            </div>
            <div className="shi-vt-field">
              <label className="shi-vt-grid-label">PAN Back</label>
              <input type="file" accept="image/*,application/pdf" className="shi-vt-input shi-vt-input-file"
                {...register("panBack", { required: "PAN back image is required" })}/>
              {errors.panBack && <p className="shi-vt-error">{errors.panBack.message}</p>}
            </div>
          </div>
        </div>

        {/* Optional */}
        <div className="shi-vt-details-card">
          <div className="shi-vt-section-title">Optional Documents</div>
          <div className="shi-vt-field">
            <label className="shi-vt-grid-label">Bank Statement (Last 3 Months)</label>
            <input type="file" accept="image/*,application/pdf" className="shi-vt-input shi-vt-input-file"
              {...register("bankStatement3m")}/>
          </div>
        </div>

        {/* Additional Info */}
        <div className="shi-vt-details-card">
          <div className="shi-vt-section-title">Additional Information</div>
          <div className="shi-vt-grid">
            <div className="shi-vt-field">
              <label className="shi-vt-grid-label">Referral ID</label>
              <input type="text" placeholder="Referral ID (if any)" className="shi-vt-input shi-vt-dark-input" {...register("referralId")}/>
            </div>
            <div className="shi-vt-field">
              <label className="shi-vt-grid-label">Minimum Balance</label>
              <span className="shi-vt-info-text">₹10,000 (Metro), ₹5,000 (Semi-Urban), ₹2,500 (Rural)</span>
            </div>
            <div className="shi-vt-field">
              <label className="shi-vt-grid-label">Interest Rate</label>
              <span className="shi-vt-info-text">Up to 2.75% p.a.</span>
            </div>
            <div className="shi-vt-field">
              <label className="shi-vt-grid-label">Video KYC</label>
              <span className="shi-vt-info-text">Required for online account opening</span>
            </div>
            <div className="shi-vt-field shi-vt-field-full">
              <label className="shi-vt-grid-label">Documents Required</label>
              <span className="shi-vt-info-text">Aadhaar, PAN, Address Proof, Passport-sized Photo</span>
            </div>
          </div>
        </div>

        {/* Submit */}
        <div className="shi-vt-form-submit">
          <button type="submit" className="shi-vt-submit-button">Open Account</button>
        </div>
      </form>
    </div>
  );
};

export default SavingAccountLanding;
